export const STORAGE_KEY = 'showEnvironmentHint';
